// extracted by mini-css-extract-plugin
export default {"root":"_212Al","priority-primary":"Bu2lg","priorityPrimary":"Bu2lg","priority-secondary":"_3uOd3","prioritySecondary":"_3uOd3"};